const textEditorConstants = {
	SET_FILE_DATA: "SET_FILE_DATA",
	CLEAR_STATE: "CLEAR_STATE",
};

export default textEditorConstants;
